import styled from 'styled-components';
import { TextField } from '@albo-ui/core';

export const HiddenInput = styled(TextField)`
  visibility: hidden;
`;
